import { $http } from './http'
import { saveAs } from 'file-saver'
import moment from 'moment'

class AnexosService {
  downloadAnexo = async (type: number, params: { start: number; end: number }) => {
    const response = await $http.get(`/invoices/report/sv-anexo/${type}`, {
      params,
      responseType: 'blob',
    })
    const typeName = type === 1 ? 'credito-fiscal' : 'factura'
    const fileName = `anexo-${typeName}-${moment().format('YYYY-MM-DD')}.csv`
    const file = new Blob([response.data], { type: 'text/plain;charset=utf-8' })
    saveAs(file, fileName)
  }
}

export default new AnexosService()
